import React, { useEffect, useState } from 'react'
import { propertyType } from '../data/data'
import { Link, useNavigate } from 'react-router-dom'
import { getPropertyCount } from '../services/ApiServices';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { setSearchValue } from '../store/slices/APIResponseSlice';
import processor from '../assets/css/plugins/ajax-loader.gif'
export default function PropertyType() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [propertyCount, setPropertyCount] = useState<any>([]);
    const [isProcessing, setProcessing] = useState<boolean>(false);

    const getProprtyListCountAPICall = () => {
        setProcessing(true);
        getPropertyCount().then((res) => {
            console.log("get property count response", res);

            if (res?.status === "success") {
                var propertyCountList: any = [];
                propertyType.forEach((item) => {
                    var count = res?.data?.find((element: any) => element.property_type === item.name);

                    propertyCountList.push({ ...item, property: count?.count ? count?.count : "0" });
                });
                console.log("propertyCountList", propertyCountList);
                setPropertyCount(propertyCountList);
                setProcessing(false);
            } else {
                setProcessing(false);
                toast.error("Something went wrong")
            }
        })
    }

    useEffect(() => {
        getProprtyListCountAPICall();
    }, [])

    const handleNavigation = (name: string) => {
        console.log("name=====>", name);

        dispatch(setSearchValue({
            propertyType: [{
                value: name,
                label: name
            }]
        }));
        navigate("/list-layout-one");
    }

    return (
        <div className="row justify-content-center gx-3 gy-3">
            {propertyCount.length === 0 && isProcessing ?
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 " style={{}}>
                    <div className="fw-bold ms-1 my-0 text-center mt-3" style={{ color: "#AFABAB" }}><img src={processor} width={'20%'} height={'20%'} /></div>
                </div> :
                propertyCount.map((item: any, index: number) => {
                    return (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6" key={index} onClick={() => handleNavigation(item?.name)}>
                            <div className="classical-cats-wrap style_2 shadows">
                                <Link to="#" className="classical-cats-boxs bg-white rounded-4 px-3 py-4" >
                                    <div className="classical-cats-icon circle bg-light-info text-primary fs-2">
                                        <i className={item.icon}></i>
                                    </div>
                                    <div className="classical-cats-wrap-content">
                                        <h4>{item.name}</h4>
                                        <p>{parseInt(item.property) <= 1 ? `${item.property} Property` : `${item.property} Properties`}</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}
